import React from "react";
import { Navigate } from "react-router-dom";
import PageLoader from "./Loader";

const ProtectedRoute = ({ isAuthenticated, isLoadingAuthCheck, children }) => {
  if (isLoadingAuthCheck) {
    return <PageLoader />;
  }

  const token = localStorage.getItem("token");
  if (!token || !isAuthenticated) {
    return <Navigate to="/login" replace />; //here replace with Login path later
  }

  return children;
};

export default ProtectedRoute;
